<script setup>
import { onMounted } from "vue";
import { useTreeStore } from '@/store/modules/trees.js';
import { KNOLIA } from "@/knolia";
import DepthElement from "@/components/DepthElement";
import MetaContainer from "@/components/MetaContainer";
import SkillList from "@/components/SkillList";
import { onBeforeRouteLeave } from "vue-router";
import { Gems } from "@/gems";
import TreeType from "../enums/TreeType";
// import SkillsTable from "../components/SkillsTable.vue";

const store = useTreeStore();

async function NewMeta() {
  await KNOLIA.CallBackEnd("post", "control-tree-element", {
    update: "meta",
    treeType: TreeType.SKILLS,
    name: "[Novo Elemento]",
  })

  store.UpdateSkillsTree()
}

onMounted(() => {
  store.GetDepth()
  store.GetSkills()
  Gems.Tooltip(document.getElementById("newMeta"), "Novo elemento", "tooltip");

  KNOLIA.ResizeSplitScreen(document.getElementById("separator"), "V");
});

onBeforeRouteLeave(() => {
  store.resetTree();
});
</script>

<template>
  <div class="splitter page-container">
    <div id="first" class="top">
      <div class="scrollbar skills-list">
        <SkillList />
        <!-- <SkillsTable class="col-6" :store="store" :tree-type="store.skills"/> -->
      </div>
    </div>
    <div id="separator" class="separator"></div>
    <div id="second" class="bottom scrollbar">
      <div class="table-container">
        <div>
          <section class="meta-comp-section">
            <div class="div-meta-title">
              <span class="meta-title">META COMPETÊNCIAS</span>
              <i id="newMeta" class="fa fa-plus-circle i-add-elem" @click="NewMeta"></i>
            </div>
            <div class="meta-comp-container">
              <span v-for="(column, index) in store.Tree" :key="column.id" class="meta-comp-item">
                <DepthElement
                  :element="column"
                  :column-depth="column.totalDepth"
                  :meta-id="column.elem_id"
                  :is-meta="true"
                  :index="index"
                  :tree-type="TreeType.SKILLS"
                />
              </span>
            </div>
          </section>
        </div>
        <MetaContainer :tree-type="TreeType.SKILLS"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../components/assets/styles/trees-style.css';

.skills-list {
  width: 100%;
  margin-bottom: 10px;
}
</style>
